import {
  SURVEYTEMPLATEDETAIL_LOADING,
  GET_SURVEYTEMPLATEDETAIL,
  GET_SURVEYTEMPLATEDETAIL_SUCCESS,
  GET_SURVEYTEMPLATEDETAIL_FAIL,
  ADD_SURVEYTEMPLATEDETAIL_SUCCESS,
  ADD_SURVEYTEMPLATEDETAIL_FAIL,
  DELETE_SURVEYTEMPLATEDETAIL_SUCCESS,
  DELETE_SURVEYTEMPLATEDETAIL_FAIL,
  UPDATE_SURVEYTEMPLATEDETAIL_SUCCESS,
  UPDATE_SURVEYTEMPLATEDETAIL_FAIL,
  SURVEYTEMPLATEDETAIL_RESET,
  SURVEYTEMPLATEDETAIL_RESET_CREATE,
} from "./actionType";

const INIT_STATE = {
  surveyTemplateDetails: [],
  surveyTemplateDetailAdded: {},
  error: {},
};

const SurveyTemplateDetail = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SURVEYTEMPLATEDETAIL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SURVEYTEMPLATEDETAIL:
          return {
            ...state,
            surveyTemplateDetails: action.payload.data,
            isSurveyTemplateDetailCreated: false,
            isSurveyTemplateDetailSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_SURVEYTEMPLATEDETAIL_FAIL:
      switch (action.payload.actionType) {
        case GET_SURVEYTEMPLATEDETAIL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isSurveyTemplateDetailCreated: false,
            isSurveyTemplateDetailSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_SURVEYTEMPLATEDETAIL: {
      return {
        ...state,
        isSurveyTemplateDetailCreated: false,
        loading: true,
      };
    }

    case SURVEYTEMPLATEDETAIL_LOADING: {
      return {
        ...state,
        isSurveyTemplateDetailCreated: false,
        loading: true,
      };
    }

    case ADD_SURVEYTEMPLATEDETAIL_SUCCESS:
      return {
        ...state,
        isSurveyTemplateDetailCreated: true,
        loading: false,
        surveyTemplateDetails: [
          ...state.surveyTemplateDetails,
          action.payload.data,
        ],
        surveyTemplateDetailAdded: action.payload.data,
      };

    case ADD_SURVEYTEMPLATEDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_SURVEYTEMPLATEDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        surveyTemplateDetails: state.surveyTemplateDetails.filter(
          (surveyTemplateDetail) =>
            surveyTemplateDetail.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_SURVEYTEMPLATEDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_SURVEYTEMPLATEDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        surveyTemplateDetails: state.surveyTemplateDetails.map(
          (surveyTemplateDetail) =>
            surveyTemplateDetail.id.toString() ===
            action.payload.data.id.toString()
              ? { ...surveyTemplateDetail, ...action.payload.data }
              : surveyTemplateDetail
        ),
      };

    case UPDATE_SURVEYTEMPLATEDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SURVEYTEMPLATEDETAIL_RESET_CREATE:
      return {
        ...state,
        isSurveyTemplateDetailCreated: false,
      };

    case SURVEYTEMPLATEDETAIL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default SurveyTemplateDetail;
